import { apiClient } from '@/shared/api/client'

export async function createMarketingQuotation(payload) {
  const response = await apiClient.post('/marketing/quotations', payload)
  return response.data
}

export async function getMarketingQuotations(params = {}) {
  const response = await apiClient.get('/marketing/quotations', {
    params,
  })
  return response.data
}

export async function getNextMarketingQuoteNumber() {
  const response = await apiClient.get('/marketing/quotations/next-number')
  return response.data
}

export async function getMarketingQuotationById(id) {
  const response = await apiClient.get(`/marketing/quotations/${id}`)
  return response.data
}

export async function getMarketingQuotationByLeadId(leadId) {
  const response = await apiClient.get(`/marketing/quotations/lead/${leadId}`)
  return response.data
}

export async function exportMarketingQuotation(id) {
  const response = await apiClient.get(`/marketing/quotations/${id}/export`, {
    responseType: 'blob',
  })
  return response.data
}

export async function getMarketingQuotationStats(params = {}) {
  const response = await apiClient.get('/marketing/quotations/stats', {
    params,
  })
  return response.data
}

export async function updateMarketingQuotation(id, payload) {
  const response = await apiClient.patch(`/marketing/quotations/${id}`, payload)
  return response.data
}

export async function deleteMarketingQuotation(id) {
  const response = await apiClient.delete(`/marketing/quotations/${id}`)
  return response.data
}
